import { createAsyncThunk } from '@reduxjs/toolkit';
import { ChangeAdvertiseStatus, BulkChangeAdvertiseStatus } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreateChangeAdvertiseStatus
} from './interface';

// Define interface for bulk status change
export interface BulkChangeAdvertiseStatusParams {
  advertiseIds: string[];
  status: string;
  rejectionReason?: string;
}

// Bulk change advertise status function
export const bulkChangeAdvertiseStatus = createAsyncThunk(
  'changeAdvertiseStatus/bulkChangeAdvertiseStatus',
  async (values: BulkChangeAdvertiseStatusParams, { rejectWithValue }) => {
    console.log("BULK API CALL - REQUEST:", values);
    try {
      // Format the payload exactly as expected by the backend
      const payload = {
        advertiseIds: values.advertiseIds,
        status: values.status,
        ...(values.rejectionReason && { rejectionReason: values.rejectionReason }),
      };
      
      console.log("Bulk API payload:", payload);
      
      // Use the dedicated bulk service
      const response = await BulkChangeAdvertiseStatus.create(payload);
      console.log("Bulk status change response:", response);
      
      // Show success message
      toastHandler({ 
        message: `${response?.count || values.advertiseIds.length} advertisements updated successfully`,
        type: 'success' 
      });
      
      return response;
    } catch (error: any) {
      console.error("BULK API ERROR:", error);
      
      // Enhanced error details
      console.error("Error details:", {
        message: error.message,
        code: error.code,
        name: error.name,
        data: error.data
      });
      
      toastHandler({
        message: error.message || 'Error updating advertisements',
        type: 'error'
      });
      
      return rejectWithValue({
        message: error.message,
        code: error.code,
        data: error.data
      });
    }
  }
);

export const createChangeAdvertiseStatus = createAsyncThunk(
  'changeAdvertiseStatus/createChangeAdvertiseStatus',
  async (values: CreateChangeAdvertiseStatus, { rejectWithValue }) => {
    try {
      const response = await ChangeAdvertiseStatus.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);